// import { useState } from 'react';
// import { Nav, Dropdown, Button, Card } from 'react-bootstrap';
// import { Info, Grid, List, ChevronDown, Users, Mail, MoreHorizontal } from 'lucide-react';

// const connectionTabs = ["My Connections", "Requests"];
// const sortOptions = ["Recently Active", "Alphabetically", "Date Added"];

// export default function ConnectionsSection() {
//   const [activeTab, setActiveTab] = useState("My Connections");
//   const [selectedSort, setSelectedSort] = useState(sortOptions[0]);
//   const [isGridView, setIsGridView] = useState(true);

//   const [requests, setRequests] = useState([
//     {
//       id: '1',
//       name: 'Rahul',
//       lastActive: '3 days ago'
//     }
//   ]);

//   const [connections, setConnections] = useState([]);

//   const handleAccept = (request) => {
//     setRequests(requests.filter(r => r.id !== request.id));
//     setConnections([...connections, {
//       id: request.id,
//       name: request.name,
//       joinDate: 'May 2023',
//       lastActive: request.lastActive
//     }]);
//   };

//   const handleIgnore = (id) => {
//     setRequests(requests.filter(r => r.id !== id));
//   };

//   const renderConnections = () => {
//     if (connections.length === 0) {
//       return (
//         <div className="d-flex align-items-center gap-2 text-muted">
//           <div className="bg-primary rounded-circle p-2 d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
//             <Info size={16} className="text-white" />
//           </div>
//           <span>Sorry, no members were found.</span>
//         </div>
//       );
//     }

//     return (
//       <div className={isGridView ? 'row g-4' : 'd-flex flex-column gap-3'}>
//         {connections.map((connection) => (
//           <div key={connection.id} className={isGridView ? 'col-md-6 col-lg-4' : 'w-100'}>
//             <Card className="h-100">
//               <Card.Body className="d-flex flex-column">
//                 <div className="d-flex justify-content-end mb-2">
//                   <Button variant="link" className="text-muted p-0">
//                     <MoreHorizontal size={20} />
//                   </Button>
//                 </div>
//                 <div className="text-center mb-3">
//                   <div className="rounded-circle bg-light mx-auto mb-3" style={{ width: '80px', height: '80px' }}>
//                     <div className="w-100 h-100 d-flex align-items-center justify-content-center text-muted">
//                       👤
//                     </div>
//                   </div>
//                   <h5 className="mb-1">{connection.name}</h5>
//                   <p className="text-muted small mb-0">
//                     Joined {connection.joinDate} • Active {connection.lastActive}
//                   </p>
//                 </div>
//                 <div className="mt-auto border-top pt-3 d-flex">
//                   <Button variant="light" className="flex-grow-1 d-flex align-items-center justify-content-center gap-2">
//                     <Users size={16} />
//                   </Button>
//                   <Button variant="light" className="flex-grow-1 d-flex align-items-center justify-content-center gap-2">
//                     <Mail size={16} />
//                   </Button>
//                 </div>
//               </Card.Body>
//             </Card>
//           </div>
//         ))}
//       </div>
//     );
//   };

//   const renderRequests = () => {
//     if (requests.length === 0) {
//       return (
//         <div className="d-flex align-items-center gap-2 text-muted">
//           <div className="bg-primary rounded-circle p-2 d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
//             <Info size={16} className="text-white" />
//           </div>
//           <span>No pending requests.</span>
//         </div>
//       );
//     }

//     return (
//       <>
//         {requests.map((request) => (
//           <Card key={request.id} className="mb-3 border">
//             <Card.Body className="d-flex align-items-center justify-content-between">
//               <div className="d-flex align-items-center gap-3">
//                 <div className="rounded-circle bg-light" style={{ width: '48px', height: '48px' }}>
//                   <div className="w-100 h-100 d-flex align-items-center justify-content-center text-muted">
//                     👤
//                   </div>
//                 </div>
//                 <div>
//                   <h6 className="mb-1">{request.name}</h6>
//                   <small className="text-muted">active {request.lastActive}</small>
//                 </div>
//               </div>
//               <div className="d-flex gap-2">
//                 <Button
//                   variant="primary"
//                   onClick={() => handleAccept(request)}
//                 >
//                   Accept
//                 </Button>
//                 <Button
//                   variant="outline-primary"
//                   onClick={() => handleIgnore(request.id)}
//                 >
//                   Ignore
//                 </Button>
//                 <Button variant="outline-secondary">
//                   View As
//                 </Button>
//               </div>
//             </Card.Body>
//           </Card>
//         ))}
//         <div className="text-muted mt-3">
//           Viewing {requests.length} member
//         </div>
//       </>
//     );
//   };

//   return (
//     <div className="card shadow-sm">
//       <div className="card-body p-0">
//         <Nav className="border-bottom gap-4 px-4">
//           {connectionTabs.map((tab) => (
//             <Nav.Item key={tab}>
//               <Nav.Link
//                 onClick={() => setActiveTab(tab)}
//                 className={`py-3 px-1 border-bottom border-3 ${
//                   activeTab === tab ? 'border-primary text-primary' : 'border-transparent text-muted'
//                 }`}
//               >
//                 {tab}
//               </Nav.Link>
//             </Nav.Item>
//           ))}
//         </Nav>

//         <div className="p-4">
//           <div className="d-flex justify-content-end gap-2 mb-4">
//             <Dropdown>
//               <Dropdown.Toggle
//                 variant="light"
//                 className="d-flex align-items-center gap-2 border"
//               >
//                 {selectedSort}
//                 <ChevronDown size={16} />
//               </Dropdown.Toggle>

//               <Dropdown.Menu>
//                 {sortOptions.map((option) => (
//                   <Dropdown.Item
//                     key={option}
//                     active={selectedSort === option}
//                     onClick={() => setSelectedSort(option)}
//                   >
//                     {option}
//                   </Dropdown.Item>
//                 ))}
//               </Dropdown.Menu>
//             </Dropdown>

//             <div className="btn-group">
//               <Button
//                 variant={isGridView ? 'primary' : 'light'}
//                 onClick={() => setIsGridView(true)}
//               >
//                 <Grid size={16} />
//               </Button>
//               <Button
//                 variant={!isGridView ? 'primary' : 'light'}
//                 onClick={() => setIsGridView(false)}
//               >
//                 <List size={16} />
//               </Button>
//             </div>
//           </div>

//           {activeTab === "My Connections" ? renderConnections() : renderRequests()}

//           {(activeTab === "My Connections" && connections.length > 0) ||
//            (activeTab === "Requests" && requests.length > 0) ? (
//             <div className="text-muted mt-3">
//               Viewing {activeTab === "My Connections" ? connections.length : requests.length} member
//               {(connections.length > 1 || requests.length > 1) ? 's' : ''}
//             </div>
//           ) : null}
//         </div>
//       </div>
//       <div className="text-muted small p-3 border-top">
//         © 2025 - TDTL LMS
//       </div>
//     </div>
//   );
// }

import { useState, useEffect } from 'react'
import axios from 'axios'
import { Nav, Dropdown, Button, Card } from 'react-bootstrap'
import { Info, Grid, List, ChevronDown } from 'lucide-react'

const connectionTabs = ['My Connections', 'Requests']
const sortOptions = ['Recently Active', 'Alphabetically', 'Date Added']

export default function ConnectionsSection() {
  const [activeTab, setActiveTab] = useState('My Connections')
  const [selectedSort, setSelectedSort] = useState(sortOptions[0])
  const [isGridView, setIsGridView] = useState(true)
  const [requests, setRequests] = useState([])
  const [connections, setConnections] = useState([])
  const token = localStorage.getItem('jwttoken') || ''

  // Fetch friend requests
  useEffect(() => {
    if (!token) return

    axios
      .get('https://tdtlworld.com/dss-kaas-backend/socialapp/friend_requests/', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const formattedRequests = response.data.map((req) => ({
          id: req.id,
          name: `${req.from_user.first_name} ${req.from_user.last_name}`,
          lastActive: 'Recently',
        }))
        setRequests(formattedRequests)
      })
      .catch((error) => console.error('Error fetching friend requests:', error))
  }, [token])

  // Fetch friends list (New API Integration)
  useEffect(() => {
    if (!token) return

    axios
      .get('https://tdtlworld.com/dss-kaas-backend/socialapp/friends/', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const formattedConnections = response.data.map((friend) => ({
          id: friend.user_id,
          name: `${friend.first_name} ${friend.last_name}`,
          email: friend.email,
          joinDate: 'Joined Recently', // Modify if API provides join date
          lastActive: 'Recently',
        }))
        setConnections(formattedConnections)
      })
      .catch((error) => console.error('Error fetching connections:', error))
  }, [token])

  // Handle Accept Friend Request
  const handleAccept = (request) => {
    axios
      .post(
        `https://tdtlworld.com/dss-kaas-backend/socialapp/friend_requests/${request.id}/handle/`,
        { action: 'accept' },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => {
        setRequests((prevRequests) =>
          prevRequests.filter((r) => r.id !== request.id)
        )
        setConnections((prevConnections) => [
          ...prevConnections,
          {
            id: request.id,
            name: request.name,
            joinDate: 'Recently',
            lastActive: request.lastActive,
          },
        ])
      })
      .catch((error) => console.error('Error accepting friend request:', error))
  }

  // Handle Ignore Friend Request
  const handleIgnore = (id) => {
    axios
      .post(
        `https://tdtlworld.com/dss-kaas-backend/socialapp/friend_requests/${id}/handle/`,
        { action: 'ignore' },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => {
        setRequests((prevRequests) => prevRequests.filter((r) => r.id !== id))
      })
      .catch((error) => console.error('Error ignoring friend request:', error))
  }

  return (
    <div className='card shadow-sm'>
      <div className='card-body p-0'>
        <Nav className='border-bottom gap-4 px-4'>
          {connectionTabs.map((tab) => (
            <Nav.Item key={tab}>
              <Nav.Link
                onClick={() => setActiveTab(tab)}
                className={`py-3 px-1 border-bottom border-3 ${
                  activeTab === tab
                    ? 'border-primary text-primary'
                    : 'border-transparent text-muted'
                }`}
              >
                {tab}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        <div className='p-4'>
          <div className='d-flex justify-content-end gap-2 mb-4'>
            <Dropdown>
              <Dropdown.Toggle
                variant='light'
                className='d-flex align-items-center gap-2 border'
              >
                {selectedSort}
                <ChevronDown size={16} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {sortOptions.map((option) => (
                  <Dropdown.Item
                    key={option}
                    active={selectedSort === option}
                    onClick={() => setSelectedSort(option)}
                  >
                    {option}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            <div className='btn-group'>
              <Button
                variant={isGridView ? 'primary' : 'light'}
                onClick={() => setIsGridView(true)}
              >
                <Grid size={16} />
              </Button>
              <Button
                variant={!isGridView ? 'primary' : 'light'}
                onClick={() => setIsGridView(false)}
              >
                <List size={16} />
              </Button>
            </div>
          </div>

          {/* Requests Section */}
          {activeTab === 'Requests' &&
            (requests.length === 0 ? (
              <div className='d-flex align-items-center gap-2 text-muted'>
                <div
                  className='bg-primary rounded-circle p-2 d-flex align-items-center justify-content-center'
                  style={{ width: '32px', height: '32px' }}
                >
                  <Info size={16} className='text-white' />
                </div>
                <span>No pending requests.</span>
              </div>
            ) : (
              requests.map((request) => (
                <Card key={request.id} className='mb-3 border'>
                  <Card.Body className='d-flex align-items-center justify-content-between'>
                    <div className='d-flex align-items-center gap-3'>
                      <div
                        className='rounded-circle bg-light'
                        style={{ width: '48px', height: '48px' }}
                      >
                        <div className='w-100 h-100 d-flex align-items-center justify-content-center text-muted'>
                          👤
                        </div>
                      </div>
                      <div>
                        <h6 className='mb-1'>{request.name}</h6>
                        <small className='text-muted'>
                          active {request.lastActive}
                        </small>
                      </div>
                    </div>
                    <div className='d-flex gap-2'>
                      <Button
                        variant='primary'
                        onClick={() => handleAccept(request)}
                      >
                        Accept
                      </Button>
                      <Button
                        variant='outline-primary'
                        onClick={() => handleIgnore(request.id)}
                      >
                        Ignore
                      </Button>
                      <Button variant='outline-secondary'>View As</Button>
                    </div>
                  </Card.Body>
                </Card>
              ))
            ))}

          {/* My Connections Section */}
          {activeTab === 'My Connections' &&
            (connections.length === 0 ? (
              <p className='text-muted'>No connections found.</p>
            ) : (
              connections.map((connection) => (
                <Card key={connection.id} className='mb-3 border'>
                  <Card.Body className='d-flex align-items-center justify-content-between'>
                    <div className='d-flex align-items-center gap-3'>
                      <div
                        className='rounded-circle bg-light'
                        style={{ width: '48px', height: '48px' }}
                      >
                        <div className='w-100 h-100 d-flex align-items-center justify-content-center text-muted'>
                          👤
                        </div>
                      </div>
                      <div>
                        <h6 className='mb-1'>{connection.name}</h6>
                        <small className='text-muted'>{connection.email}</small>
                      </div>
                    </div>
                    <Button variant='outline-secondary'>Message</Button>
                  </Card.Body>
                </Card>
              ))
            ))}
        </div>
      </div>
    </div>
  )
}
